import React from "react";
import { Switch, Route, HashRouter, Redirect } from "react-router-dom";
import Login from "../components/auth/Login";
import Home from "../components/home/Home";
import ProjectCreateEdit from "../components/project/ProjectCreateEdit";
import ProjectList from "../components/project/ProjectList";
import ProjectView from "../components/project/ProjectView";
import UserCreateEdit from "../components/user/UserCreateEdit";
import UserList from "../components/user/UserList";
import UserView from "../components/user/UserView";
import MRXUserList from "../components/user/MRXUserList";
import Approval from "../components/auth/Approval";

export const AllRouter = () => {
  return (
    // <HashRouter>
    <Switch>
      {/* <Route exact path="/login" >
                    <Login />
                </Route> */}
      <Route exact path="/home">
        <Home />
      </Route>
      <Route exact path="/mrx-user-list">
        <MRXUserList />
      </Route>
      <Route exact path="/user-list">
        <UserList />
      </Route>
      <Route exact path="/user-create">
        <UserCreateEdit />
      </Route>
      <Route exact path="/user-edit/:id">
        <UserCreateEdit />
      </Route>
      <Route exact path="/user-view/:id">
        <UserView />
      </Route>
      <Route exact path="/project-list">
        <ProjectList />
      </Route>
      <Route exact path="/project-view/:id">
        <ProjectView />
      </Route>
      <Route exact path="/project-edit/:id">
        <ProjectCreateEdit />
      </Route>
      <Route exact path="/project-create">
        <ProjectCreateEdit />
      </Route>

      <Route
        exact
        path="/"
        render={({ location }) => (
          <Redirect to={location.hash.replace("#", "")} />
        )}
      />
    </Switch>
    // </HashRouter>
  );
};

export const AuthRouter = () => {
  return (
    <Switch>
      <Route path="/waiting-for-approval/:token">
      <Approval />
    </Route>
      <Route path="/">
        <Login />
      </Route>
    </Switch>
  );
};


